<template>
    <el-dialog v-dialogDrag class="dialog" width="500px" :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                菜单权限
            </div>
        </div>
        <div class="dialog_body">
            <el-table
                    ref="treeTable"
                    :data="menuList"
                    height="500"
                    style="width: 100%;"
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    row-key="menuId"
                    border
                    default-expand-all
                    @row-click="rowClick"
                    @select="handleSelectionChange"
                    @select-all="selectAll"
                    :tree-props="{children: 'child', hasChildren: 'hasChildren'}">
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        prop="menuName"
                        label="功能菜单"
                        width="250">
                    <template slot-scope="scope">
                        <template>
                            <i style="font-size:15px;color:orange;" class="el-icon-document"></i>
                            {{scope.row["menuName"]}}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="menu"
                        label="类别">
                    <template slot-scope="scope">
                        <template>
                            <span v-if="scope.row['menu']">菜单</span>
                            <span v-if="!scope.row['menu']">按钮</span>
                        </template>
                    </template>
                </el-table-column>
            </el-table>

            <div style="text-align: center;padding: 10px 0">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="saveRoleMenus">保 存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "grantTableDialog",
        props: ['formData', 'loading'],
        data() {
            return {
                dialogVisible: true,

                dialoading: false,
                menuList: [],
                defaultKeys: [],
                rows: [],
            }
        },
        // watch:{
        //   loading(val){
        //     this.dialoading = val;
        //   }
        // },
        async created() {
            await this.initTree();

            this.defaultSelect(this.menuList);
        },
        methods: {
            headerStyle() {
                return "text-align:center;height:45px;line-hight:45px;padding: 1px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle(row) {
                if (row.column.property !== "menuName")
                    return "text-align:center"
                else
                    return "text-align:left"
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            async initTree() {
                await this.getListData();
            },
            getTreeData(arr, parentId) {
                arr.forEach(item=>{
                    delete item.child
                })

                let map={};
                arr.forEach(item=>{
                    map[item.menuId] = item;
                })

                var val = [];
                arr.forEach(item=>{
                    let parent = map[item.parentId];
                    if(parent){
                        (parent.child||(parent.child=[])).push(item);
                    }else{
                        val.push(item);
                    }
                })

                arr = arr.filter(item=>{
                    return item.parentId === parentId
                })
                return arr;


                // let inArr = arr.filter(item => {
                //     return item.parentId == parentId;
                // })
                // if (inArr && inArr.length > 0) {
                //     inArr.map(item => {
                //         item.child = this.getTreeData(arr, item.menuId)
                //         return item;
                //     })
                // } else {
                //     return [];
                // }
                // return inArr;
            },
            async getListData() {
                this.dialoading = true;
                let param = {
                    url: "/role/getMenuTreeJson",
                    param: {
                        roleId: this.formData.roleId,
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == '0') {
                    const list = data.data.menuList;
                    this.menuList = this.getTreeData(list, "0");
                    //     this.defaultKeys = data.defArray;
                }
                this.dialoading = false;
            },
            async saveRoleMenus() {
                this.rows = this.$refs.treeTable.selection;
                let menuIds = "";
                let buttonIds = "";
                this.rows.map(row => {
                    if (row.checked) {
                        if (row.menu) {
                            if (menuIds == "") {
                                menuIds = row.menuId
                            } else {
                                menuIds = menuIds + "," + row.menuId
                            }
                        } else {
                            if (buttonIds == "") {
                                buttonIds = row.menuId
                            } else {
                                buttonIds = buttonIds + "," + row.menuId
                            }
                        }
                    }
                });

                this.dialoading = true;

                let param = {
                    ...this.formData,
                    menuIds:menuIds,
                    buttonIds:buttonIds,
                }
                const data = await this.$sqlOpt.save.save(param, "/role/save");
                this.dialoading = false;

                if (data.infoCode === '0') {
                    this.close();
                    this.$message({message: '保存成功', type: 'success'});
                }
            },
            //点击全选复选框
            selectAll() {
                let data = this.$refs.treeTable.data
                data.forEach(item => {
                    if (item.checked == true) {
                        this.clearRow([item]);
                    } else {
                        this.checkRow([item]);
                    }
                })
            },
            //点击列表
            rowClick() {
            },
            //点击复选框事件
            handleSelectionChange(select, row) {
                if (row.checked == true) {
                    this.$refs.treeTable.toggleRowSelection(row, false);
                    this.clearRow([row]);
                } else {
                    this.$refs.treeTable.toggleRowSelection(row, true);
                    this.checkRow([row]);
                }
            },
            //取消选中递归
            clearRow(data) {
                Array.from(data).forEach(row => {
                    row.checked = false;
                    this.$refs.treeTable.toggleRowSelection(row, false);
                    if (row.child) this.clearRow(row.child);
                })
            },
            //选中递归
            checkRow(data) {
                Array.from(data).forEach(row => {
                    row.checked = true;//选中是字段值为true
                    this.$refs.treeTable.toggleRowSelection(row, true);
                    if (row.child) this.checkRow(row.child);
                })
            },
            //默认选中
            defaultSelect(data) {
                if (data.length > 0) {
                    this.$nextTick(() => {
                        data.forEach(item => {
                            if (item.checked) {
                                this.$refs.treeTable.toggleRowSelection(item, true);
                            }
                            // this.$refs.treeTable.toggleRowSelection(item, true);
                            if (item.child) this.defaultSelect(item.child);
                        })
                    })
                }
            },

        },
    }
</script>

